import styled from 'styled-components';

export const RateComp = styled.div`
  background: linear-gradient(0deg, #e8f3ff, #e8f3ff), #d1e5ff;
  border: 1px solid #c3e1ff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  padding: 12px;
  position: fixed;
  bottom: 55px;
  left: 10px;
  right: 10px;

  @media (min-width: 768px) {
    & {
      width: 500px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 24px;
      margin: 0 auto;
    }
  }
`;

export const RateTitle = styled.h4`
  display: flex;
  align-itms: center;
  justify-content: space-between;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #141823;

  @media (min-width: 768px) {
    & {
      margin-bottom: 32px;
      font-size: 18px;
      line-height: 26px;
    }
    .greyCross--big {
      position: absolute;
      right: 24px;
      top: 24px;
    }
  }
`;

export const RateFeedBack = styled.div`
  background: #ffffff;
  box-shadow: 0px -2px 4px rgba(20, 24, 35, 0.2);
  border-radius: 16px 16px 0px 0px;
  padding: 25px;
  position: fixed;
  bottom: 50;
  z-index: 2;
  display: flex;
  flex-direction: column;
  width: 100%;
  left: 0;

  & h5 {
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 28px;
    color: #141823;
  }

  & p {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 26px;
    color: #777777;
    font-family: Roboto;
    font-weight: normal;
  }

  & .feedBack {
    margin-right: unset;
  }

  @media (min-width: 768px) {
    & {
      width: 580px;
      top: 30%;
      left: 30%;
      border-radius: 8px;
      align-items: center;
      justify-content: center;
      padding: 40px;
      text-align: center;
      bottom: unset;
    }

    .greyCross--big {
      position: absolute;
      top: 24px;
      right: 24px;
    }

    & h5 {
      font-size: 22px;
      line-height: 23px;
      margin-bottom: 38px;
    }

    & .feedBack {
      font-size: 16px;
      line-height: 22px;
    }
  }
`;

export const RateLinks = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  & span {
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    color: #2276e3;
    width: 130px;
    text-align: center;
    margin-right: 18px;
  }

  & a {
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    color: #2276e3;
    width: 130px;
    text-align: center;
    margin-right: 18px;
  }
`;

export const RateStar = styled.div`
  display: flex;
  & p {
    margin-right: 26px;
  }
  & p:last-child {
    margin-right: unset;
  }
  @media (min-width: 768px) {
    & p {
      margin-right: 36px;
    }
  }
`;

export const FeedBackBtn = styled.button`
  background: #2276e3;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  outline: none;
  border: none;
  height: 44px;
  width: 152px;
  @media (min-width: 768px) {
    width: 300px;
  }
`;

export const BackDrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1;
  width: 100%;
  height: 100%;
`;

export const RatePlayStore = styled.div`
  background: #ffffff;
  box-shadow: 0px -2px 4px rgba(20, 24, 35, 0.2);
  border-radius: 16px 16px 0px 0px;
  padding: 25px;
  position: fixed;
  bottom: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  width: 100%;
  left: 0;

  & h5 {
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 12px;
    text-align: center;
    color: #141823;
  }

  & p {
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    margin-bottom: 25px;
    color: #777777;
    font-family: Roboto;
    font-weight: normal;
  }

  & div .blackCross {
    position: absolute;
    right: 25px;
    top: 25px;
  }

  & .playStoreInfo {
    margin-right: unset;
  }
`;

export const RatePlayStoreImg = styled.div`
  width: 158px;
  height: 151px;
  flex-shrink: 0;
  margin-bottom: 12px;
  align-self: center;
  > img{
   width:100%;
  }
`;

export const RateLinkBtn = styled.button`
  background: #2276e3;
  border-radius: 8px;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
  padding: 12px 16px;
  position: relative;

  & .playStoreIcon {
    position: absolute;
    left: 16px;
  }
`;

export const RateSubInfo = styled.div`
  background: #fff4e3;
  border: 0.5px solid #ffe8ad;
  border-radius: 10.5px;
  margin-bottom: 30px;
  font-style: italic;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #46484d;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 22px;
  font-weight: normal;
  & .smileyIcon {
    position: absolute;
    left: -6px;
  }
`;
